import React from 'react'

import NavigationItems from '../NavigationItems/NavigationItems'
import DrawerToggle from './SideDrawer/DrawerToggle/DrawerToggle'
import Logo from '../Logo/Logo'
import classes from './Toolbar.module.css'

const toolbar = (props) => {
    return (
        <header className={classes.Toolbar}>
             <DrawerToggle clicked={props.drawerToggleClicked} />
             <div className={classes.Logo}>
            <Logo />
            </div>
            <nav className={classes.DesktopOnly}>
            <NavigationItems isLoggedIn={props.isLoggedIn}/>
        </nav>
        </header>
    )
}

export default toolbar;